import { createSlice } from "@reduxjs/toolkit";
import { getCommAuditTrailsAction } from "../../actions/CommAuditTrails/commAuditTrailsActions";

const initialState = {
  commAuditTrails: [],
  loading: false,
  error: null,
};

const commAuditTrailsSlice = createSlice({
  name: "commAuditTrails",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommAuditTrailsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommAuditTrailsAction.fulfilled, (state, action) => {
        state.loading = false;
        const raw = action.payload?.data || action.payload;
        state.commAuditTrails = Array.isArray(raw) ? raw : Object.values(raw);
      })
      .addCase(getCommAuditTrailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetState } = commAuditTrailsSlice.actions;
export default commAuditTrailsSlice.reducer;
